import { bannerTypes, schemas } from '../constants/constants';
import { setAppId } from './queryParamsHelpers';

// Ports the ineligibility gates legacy banner components checked on the FE before
// firing a request, so UBC stops making requests legacy never made.

// Skip if banners on browse page has no category
const browseEligibilityGates = [
  {
    reason: 'gate-browse-no-category',
    isIneligible: ({ schema, category }) => schema === schemas.BROWSE_SPONSORED && !category
  }
];

// Skip if skyscraper is event_browse_sponsored schema or not desktop
const skyscraperEligibilityGates = [
  {
    reason: 'gate-skyscraper-not-desktop',
    isIneligible: ({ experienceContext }) => experienceContext?.channel !== 'desktop'
  },
  {
    reason: 'gate-skyscraper-event-browse',
    isIneligible: ({ schema }) => schema === schemas.EVENT_BROWSE_SPONSORED
  }
];

// Skip if customer is b2b or schema is cat_sponsored
const ingridEligibilityGates = [
  {
    reason: 'gate-ingrid-cat-sponsored',
    isIneligible: ({ schema }) => schema === schemas.CAT_SPONSORED
  },
  {
    reason: 'gate-ingrid-b2b',
    isIneligible: ({ customerType }) => customerType === 'b2b'
  }
];

// Skip if channel is mobileapp
const pipEligibilityGates = [
  {
    reason: 'gate-pip-mobileapp',
    isIneligible: ({ experienceContext }) => setAppId({ experienceContext }) === 'mobileapp'
  }
];

const eligibilityGatesByBannerType = {
  [bannerTypes.SKYSCRAPER]: skyscraperEligibilityGates,
  [bannerTypes.INGRID]: ingridEligibilityGates,
  [bannerTypes.MIDDLE]: pipEligibilityGates
};

/**
 * Determines if legacy ineligibility gate applies to a UBC banner request.
 */
export const resolveBannerEligibilityReason = ({
  bannerType,
  schema,
  experienceContext = {},
  pageContext = {}
} = {}) => {
  const customerType = experienceContext?.customer?.type ? experienceContext.customer.type : 'b2c';
  const category = pageContext?.data?.searchModel?.metadata?.categoryID;
  const eligibilityContext = {
    bannerType, schema, experienceContext, pageContext, customerType, category
  };

  const eligibilityGates = [
    ...browseEligibilityGates,
    ...(eligibilityGatesByBannerType[bannerType] || [])
  ];

  return eligibilityGates.find((gate) => gate.isIneligible(eligibilityContext))?.reason || 'eligible';
};

export const checkBannerEligibility = (params) => {
  const eligibilityReason = resolveBannerEligibilityReason(params);
  return { isEligible: eligibilityReason === 'eligible', eligibilityReason };
};
